exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mainSearch__searchBar___3AGrs{display:none}@media(min-width:1000px){.mainSearch__searchBar___3AGrs{display:block;max-width:700px;width:100%;position:relative;margin-left:0;margin-bottom:50px;margin-top:40px;display:visible!important}}", ""]);

// exports
exports.locals = {
	"searchBar": "mainSearch__searchBar___3AGrs"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/components/FundExplorerPage/overrides/mainSearch.pcss
// module id = 890
// module chunks = 0